import { createTheme } from '@material-ui/core/styles';

const LightTheme = createTheme({
  palette: {
    primary: {
      light: '#009BDD',
      main: '#1D71B8',
      dark: '#1D71B8',
    },
    secondary: {
      dark: '#E45501',
      main: '#FA5A00',
      light: '#FA5A0026',
    },
    info: {
      light: '#D5D5D5',
      main: '#D6D6D6',
      dark: '#C1C1C1',
    },
    error: {
      light: '#FA5A00',
      main: '#D80000',
      dark: '#D80000',
    },
    action: {
      hover: '#ccc'
    },
    background: {
      paper: '#F5F5F5',
      default: '#FFF'
    },
    text: {
      primary: '#6D6E71',
      secondary: '#1D71B8',
      hint: '#4F4F4F'
    }
  },
  paletteUserMenu: {
    Icon: {
      primary: {
        light: "#009BDD",
        main: "#1D71B8",
        dark: "#1D71B8",
      }
    }
  },
  paletteDataTable: {
    border: {
      borderRadius: '10px'
    },
    table: {
      columnsBackgroundColor: "#009BDD",
      columnsLetterColor: "#FFFFFF",
      columnsArrowColor: "#FFFFFF 0% 0% no-repeat padding-box;",
      trashIconColor: "#009BDD"
    }
  },
  paletteViewLayout:{
    title: {
      color: "#1D71B8"
    },
    border:{
      border: '1px solid #009BDD',
      borderRadius: '10px;'
    }
  },
  palleteFormLayout: {
    iconEspecialButton:{
      initial:{
        backgrounColor: 'white',
        border: '1px solid #A8A8A8',
        color: '#6D6E71'
      },
      hover: {
        backgroundColor: '#FA5A00',
        border: 'none',
        boxshadow: 'none',
        color: 'white'
      }
    }
  },
  palettePrimaryButton: {
    color: "#1D71B8",
    colorHover: "#1D71B8",
    textColor: 'white'
  },
  typography: {
    allVariants: {
      fontFamily: 'Muli'
    },

    subtitle1: {
      textAlign: 'left',
      font: 'normal normal 600 16px/20px Muli',
      letterSpacing: '0px',
      fontWeight: 600,
      lineHeight: 1.3,
      color: '#6D6E71',
      opacity: 1
    },
    body1: {
      textAlign: 'left',
      font: 'normal normal 600 16px/20px Muli',
      letterSpacing: '0px',
      color: '#6D6E71',
      fontWeight: 600,
      opacity: 1
    },
    h6: {
      fontWeight: 'normal',
      fontFamily: 'Muli',
      color: '#6D6E71',
      fontSize: '14px'
    }
  },
  overrides: {
    MuiFilledInput: {
      root:{
        '&.Mui-disabled':{
          backgroundColor: 'transparent'
        }
      }
    },
    MuiSelect: {
      root:{
        background: 'white',
        boxShadow: '0px 3px 3px #0000001A',
        border: '1px solid #D5D5D5',
      },
      select: {
        borderRadius: '10px',
      }
    }
  }
})

export default LightTheme;
